<app-toast />
<p-confirmDialog [style]="{ width: '26rem' }"></p-confirmDialog>
<section class="dashboard-atividades">
    <div class="layout-dashboard" [class.sem-filtros]="!filtrosVisiveis()">
        @if (filtrosVisiveis()) {
            <aside class="coluna-filtros">
                <app-filtros-atividades-comissoes
                    [filtros]="filtrosAtivos"
                    [responsaveisPesquisa]="responsaveisPesquisa"
                    [carregandoResponsaveisPesquisa]="carregandoResponsaveisPesquisa"
                    [erroPesquisaResponsaveis]="erroPesquisaResponsaveis"
                    (pesquisarResponsaveis)="aoPesquisarResponsaveis($event)"
                    (aplicarFiltros)="aoAplicarFiltros($event)"
                    (limparFiltros)="aoLimparFiltros()"
                ></app-filtros-atividades-comissoes>
            </aside>
        }

        <section class="coluna-conteudo">
            <p-card class="w-full">
                <app-tabela-atividades-comissoes
                    [atividades]="atividadesFiltradas"
                    [totalRegistros]="totalRegistrosAtividades"
                    [situacoesResumo]="situacoesResumoAtividades"
                    [first]="primeiraLinhaAtividades"
                    [rows]="linhasPorPaginaAtividades"
                    [atividadeSelecionada]="atividadeSelecionada"
                    [carregando]="carregandoAtividades"
                    [itensOpcoes]="itensOpcoes()"
                    [filtrosVisiveis]="filtrosVisiveis()"
                    (selecionarAtividade)="aoSelecionarAtividade($event)"
                    (acaoTabela)="aoExecutarAcaoTabela($event)"
                    (paginaAlterada)="aoMudarPaginaAtividades($event)"
                    (alternarFiltros)="alternarFiltros()"
                ></app-tabela-atividades-comissoes>
            </p-card>
        </section>
    </div>
</section>

<p-dialog
    appDialogoPadrao="pi pi-building"
    descricao="Atividade da comissão."
    closeAriaLabel="Fechar"
    [header]="tituloDialogAtividade"
    [(visible)]="exibirDialogAtividade"
    [style]="{ width: 'min(54rem, calc(100vw - 2rem))' }"
    styleClass="dialogo-atividade-custom"
    appendTo="body"
    (onHide)="fecharDialogAtividade()"
>
    <div [formGroup]="formularioAtividade" class="py-2 px-1 flex flex-col gap-4">
        <!-- Informações de Atividade -->
        <app-card-content [icon]="'pi pi-info-circle'" [title]="'Informações de Atividade'">
            <div class="flex flex-col gap-4">
                <div class="grid grid-cols-12 gap-3 informacoes-atividade-grid">
                    <!-- Código da Atividade -->
                    <div class="col-span-12 md:col-span-6 lg:col-span-4 flex flex-col gap-1.5">
                        <label for="idTarefa" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Código da Atividade</label>
                        <input id="idTarefa" pInputText readonly [value]="formularioAtividade.controls.idTarefa.value ? formularioAtividade.controls.idTarefa.value : proximoCodigoAtividade || 'Carregando...'" class="w-full" />
                    </div>

                    <!-- Situação -->
                    <div class="col-span-12 md:col-span-6 lg:col-span-4 flex flex-col gap-1.5">
                        <label for="idSituacaoTarefa" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Situação da Atividade</label>
                        <p-select
                            inputId="idSituacaoTarefa"
                            formControlName="idSituacaoTarefa"
                            [options]="situacoesAtividade"
                            optionLabel="dsSituacaoTarefa"
                            optionValue="idSituacaoTarefa"
                            [loading]="carregandoSituacoesAtividade"
                            placeholder="Selecionar situação"
                            appendTo="body"
                            styleClass="w-full"
                        ></p-select>
                    </div>
                </div>

                <!-- Datas -->
                <div class="grid grid-cols-2 gap-3">
                    <div class="flex flex-col gap-1.5">
                        <label for="dtInicio" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Data Início</label>
                        <input id="dtInicio" type="date" formControlName="dataInicio" class="w-full p-inputtext p-component" />
                    </div>
                    <div class="flex flex-col gap-1.5">
                        <label for="dtFim" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Data Fim</label>
                        <input id="dtFim" type="date" formControlName="dataFim" class="w-full p-inputtext p-component" />
                    </div>
                </div>

                <!-- Protocolo -->
                <div class="flex flex-col gap-1.5">
                    <label for="idProtocolo" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Protocolo (Opcional)</label>
                    <div class="campo-protocolo-atividade">
                        <input id="idProtocolo" pInputText readonly [value]="protocoloAtividadeSelecionado" placeholder="Nenhum protocolo selecionado" class="w-full min-w-0" />
                        <button type="button" class="botao-icone" (click)="abrirPesquisaProtocoloAtividade()" title="Buscar protocolo">
                            <i class="pi pi-search"></i>
                        </button>
                        <button type="button" class="botao-icone limpar" (click)="limparProtocoloAtividade()" title="Limpar protocolo">
                            <i class="pi pi-times"></i>
                        </button>
                    </div>
                    @if (erroPesquisaProtocoloAtividade) {
                        <span class="text-xs text-red-500 font-semibold">{{ erroPesquisaProtocoloAtividade }}</span>
                    }
                </div>
            </div>
        </app-card-content>

        <!-- Detalhes da Atividade -->
        <app-card-content [icon]="'pi pi-file-edit'" [title]="'Detalhes da Atividade'" [subtitle]="'Insira os detalhes da atividade abaixo.'">
            <div class="flex flex-col gap-4">
                <!-- Comissão / Núcleo -->
                <div class="flex flex-col gap-1.5">
                    <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Comissão / Núcleo</label>
                    <app-seletor-arvore-comissao
                        formControlName="idEstruturaOrganizacional"
                        [tiposComissao]="tiposComissao"
                        [estruturasComissao]="estruturasComissao"
                        [carregando]="carregandoEstruturasComissao"
                        [erro]="erroEstruturasComissao"
                        placeholder="Selecionar Comissão / Núcleo"
                    ></app-seletor-arvore-comissao>
                </div>

                <!-- Responsável -->
                <div class="flex flex-col gap-1.5">
                    <label class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Responsável</label>
                    <div class="flex gap-2">
                        <input
                            pInputText
                            readonly
                            [value]="formularioAtividade.controls.nomeResponsavel.value ? formularioAtividade.controls.nomeResponsavel.value + ' (' + formularioAtividade.controls.sgUfResponsavel.value + ')' : ''"
                            placeholder="Nenhum responsável selecionado"
                            class="flex-1"
                        />
                        <button type="button" class="botao-icone" (click)="abrirPesquisaResponsavelCadastro()" title="Buscar Responsável">
                            <i class="pi pi-search"></i>
                        </button>
                    </div>
                </div>

                <!-- Descrição -->
                <div class="flex flex-col gap-1.5">
                    <label for="dsTarefa" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Descrição da Atividade</label>
                    <textarea id="dsTarefa" pInputText formControlName="descricao" rows="3" placeholder="O que deve ser feito" class="w-full" style="resize: vertical; min-height: 80px"></textarea>
                </div>

                <!-- Observação -->
                <div class="flex flex-col gap-1.5">
                    <label for="txObservacao" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Observação / Detalhes</label>
                    <textarea id="txObservacao" pInputText formControlName="observacao" rows="3" placeholder="Observações adicionais (opcional)" class="w-full" style="resize: vertical; min-height: 80px"></textarea>
                </div>

                <!-- Reunião -->
                <div class="flex flex-col gap-1.5">
                    <label for="idReuniao" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Código Reunião (Opcional)</label>
                    <input id="idReuniao" type="number" formControlName="idReuniao" placeholder="Código da reunião" class="w-full p-inputtext p-component" />
                </div>
            </div>
        </app-card-content>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 pt-2">
            <button type="button" pButton label="Cancelar" severity="secondary" [outlined]="true" (click)="fecharDialogAtividade()"></button>
            <button
                type="button"
                pButton
                label="Salvar Atividade"
                severity="primary"
                [appCan]="roleSalvarAtividade"
                [disabled]="
                    !formularioAtividade.controls.descricao.value ||
                    !formularioAtividade.controls.idResponsavel.value ||
                    !formularioAtividade.controls.dataInicio.value ||
                    !formularioAtividade.controls.idEstruturaOrganizacional.value ||
                    !formularioAtividade.controls.idSituacaoTarefa.value
                "
                (click)="salvarAtividade()"
            ></button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-briefcase"
    descricao="Protocolo que será tratado na atividade."
    closeAriaLabel="Fechar"
    header="Seleção de Protocolo"
    [(visible)]="exibirDialogProtocolos"
    [style]="{ width: 'min(46rem, calc(100vw - 2rem))' }"
    appendTo="body"
    (onHide)="fecharPesquisaProtocoloAtividade()"
>
    <div class="flex flex-col gap-4 py-2 px-1">
        <app-card-content [icon]="'pi pi-filter'" [title]="'Filtros de Pesquisa'">
            <div class="grid grid-cols-12 gap-3 items-end">
                <div class="col-span-12 md:col-span-7 flex flex-col gap-1.5">
                    <label for="filtroTipoProtocolo" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Tipo de protocolo</label>
                    <select id="filtroTipoProtocolo" class="p-inputtext p-component w-full" [(ngModel)]="filtroTipoProtocolo" [disabled]="carregandoTiposProtocolo">
                        @for (tipo of tiposProtocolo; track tipo.idTipoProtocolo) {
                            <option [ngValue]="tipo.idTipoProtocolo">{{ tipo.dsTipoProtocolo }}</option>
                        }
                    </select>
                </div>
                <div class="col-span-6 md:col-span-2 flex flex-col gap-1.5">
                    <label for="filtroNuProtocolo" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Número</label>
                    <input id="filtroNuProtocolo" pInputText inputmode="numeric" maxlength="6" [(ngModel)]="filtroNuProtocolo" (keyup.enter)="pesquisarProtocolosAtividade()" />
                </div>
                <div class="col-span-4 md:col-span-2 flex flex-col gap-1.5">
                    <label for="filtroAnoProtocolo" class="text-[10px] font-bold text-surface-400 dark:text-surface-500 uppercase tracking-widest ml-0.5">Ano</label>
                    <input id="filtroAnoProtocolo" pInputText inputmode="numeric" maxlength="4" [(ngModel)]="filtroAnoProtocolo" (keyup.enter)="pesquisarProtocolosAtividade()" />
                </div>
                <div class="col-span-2 md:col-span-1 flex justify-end">
                    <button type="button" class="botao-icone" [disabled]="carregandoProtocolos" (click)="pesquisarProtocolosAtividade()" title="Pesquisar">
                        @if (carregandoProtocolos) {
                            <i class="pi pi-spin pi-spinner"></i>
                        } @else {
                            <i class="pi pi-search"></i>
                        }
                    </button>
                </div>
            </div>
        </app-card-content>

        @if (erroPesquisaProtocoloAtividade) {
            <div class="text-xs text-red-500 font-semibold">{{ erroPesquisaProtocoloAtividade }}</div>
        }

        <app-card-content [icon]="'pi pi-file'" [title]="'Resultados'">
            <div class="max-h-72 overflow-y-auto border border-surface-200 dark:border-surface-700 rounded-md">
                @if (carregandoProtocolos) {
                    <div class="p-4 text-center text-sm text-muted-color">Carregando...</div>
                } @else {
                    <table class="w-full border-collapse">
                        <thead>
                            <tr class="bg-surface-50 dark:bg-surface-800 text-left border-b border-surface-200 dark:border-surface-700">
                                <th class="p-2 text-xs font-bold text-muted-color cursor-pointer" (click)="ordenarProtocolos('nuProtocolo')">Número</th>
                                <th class="p-2 text-xs font-bold text-muted-color cursor-pointer" (click)="ordenarProtocolos('nuAnoProtocolo')">Ano</th>
                                <th class="p-2 text-xs font-bold text-muted-color cursor-pointer" (click)="ordenarProtocolos('dsTipoProtocolo')">Tipo do Protocolo</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for (protocolo of protocolosPesquisa; track protocolo.idProtocolo) {
                                <tr
                                    class="hover:bg-surface-100 dark:hover:bg-surface-800 cursor-pointer border-b border-surface-100 dark:border-surface-800"
                                    [class.bg-primary-50]="protocoloPesquisaSelecionado?.idProtocolo === protocolo.idProtocolo"
                                    (click)="selecionarProtocoloPesquisa(protocolo)"
                                    (dblclick)="confirmarSelecaoProtocoloAtividade()"
                                >
                                    <td class="p-2 text-sm text-color font-semibold">{{ protocolo.nuProtocolo }}</td>
                                    <td class="p-2 text-sm text-color">{{ protocolo.nuAnoProtocolo }}</td>
                                    <td class="p-2 text-sm text-color">{{ protocolo.dsTipoProtocolo }}</td>
                                </tr>
                            } @empty {
                                <tr>
                                    <td colspan="3" class="p-4 text-center text-sm text-muted-color">Nenhum protocolo encontrado.</td>
                                </tr>
                            }
                        </tbody>
                    </table>
                }
            </div>
        </app-card-content>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 pt-2">
            <button type="button" pButton label="Fechar" severity="secondary" [outlined]="true" (click)="fecharPesquisaProtocoloAtividade()"></button>
            <button type="button" pButton label="OK" severity="primary" [disabled]="!protocoloPesquisaSelecionado" (click)="confirmarSelecaoProtocoloAtividade()"></button>
        </div>
    </ng-template>
</p-dialog>

<p-dialog
    appDialogoPadrao="pi pi-users"
    descricao="Quem responde pela atividade."
    closeAriaLabel="Fechar"
    header="Buscar Responsável"
    [(visible)]="exibirDialogResponsaveis"
    [style]="{ width: '450px', border: 'none' }"
    styleClass="dialogo-busca-responsavel-custom"
    appendTo="body"
    (onHide)="fecharPesquisaResponsavelCadastro()"
>
    <div class="flex flex-col gap-4 py-2 px-1">
        <div class="flex gap-2">
            <input pInputText [(ngModel)]="filtroResponsavelNome" placeholder="Buscar por nome" class="flex-1" (keyup.enter)="pesquisarResponsaveisCadastro()" />
            <select class="p-inputtext p-component" style="width: 80px" [(ngModel)]="filtroResponsavelUf">
                <option value="BR">BR</option>
                <option value="AC">AC</option>
                <option value="AL">AL</option>
                <option value="AP">AP</option>
                <option value="AM">AM</option>
                <option value="BA">BA</option>
                <option value="CE">CE</option>
                <option value="DF">DF</option>
                <option value="ES">ES</option>
                <option value="GO">GO</option>
                <option value="MA">MA</option>
                <option value="MT">MT</option>
                <option value="MS">MS</option>
                <option value="MG">MG</option>
                <option value="PA">PA</option>
                <option value="PB">PB</option>
                <option value="PR">PR</option>
                <option value="PE">PE</option>
                <option value="PI">PI</option>
                <option value="RJ">RJ</option>
                <option value="RN">RN</option>
                <option value="RS">RS</option>
                <option value="RO">RO</option>
                <option value="RR">RR</option>
                <option value="SC">SC</option>
                <option value="SP">SP</option>
                <option value="SE">SE</option>
                <option value="TO">TO</option>
            </select>
            <button type="button" pButton icon="pi pi-search" severity="primary" (click)="pesquisarResponsaveisCadastro()"></button>
        </div>

        @if (erroPesquisaResponsaveisCadastro) {
            <div class="text-xs text-red-500 font-semibold">{{ erroPesquisaResponsaveisCadastro }}</div>
        }

        <div class="max-h-60 overflow-y-auto border border-surface-200 dark:border-surface-700 rounded-lg">
            @if (carregandoResponsaveisCadastro) {
                <div class="p-4 text-center text-sm text-muted-color">Carregando...</div>
            } @else {
                <table class="w-full border-collapse">
                    <thead>
                        <tr class="bg-surface-50 dark:bg-surface-800 text-left border-b border-surface-200 dark:border-surface-700">
                            <th class="p-2 text-xs font-bold text-muted-color">UF</th>
                            <th class="p-2 text-xs font-bold text-muted-color">Nome</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (resp of responsaveisCadastro; track resp.idSolicitante) {
                            <tr class="hover:bg-surface-100 dark:hover:bg-surface-800 cursor-pointer border-b border-surface-100 dark:border-surface-800" (click)="selecionarResponsavelCadastro(resp)">
                                <td class="p-2 text-sm text-color">{{ resp.ufSgUf }}</td>
                                <td class="p-2 text-sm text-color font-semibold">{{ resp.nmSolicitante }}</td>
                            </tr>
                        } @empty {
                            <tr>
                                <td colspan="2" class="p-4 text-center text-sm text-muted-color">Nenhum responsável encontrado.</td>
                            </tr>
                        }
                    </tbody>
                </table>
            }
        </div>
    </div>
    <ng-template pTemplate="footer">
        <div class="flex justify-end gap-2 pt-2">
            <button type="button" pButton label="Fechar" severity="secondary" [outlined]="true" (click)="fecharPesquisaResponsavelCadastro()"></button>
        </div>
    </ng-template>
</p-dialog>
